module.exports = __webpack_public_path__ + "img/metrics--icon.6115d4ba.svg";